import React from 'react';
import { Select } from 'antd';
import styled from 'styled-components';
import languages from 'utils/languages';

const Wrapper = styled.div`
  text-align: center;
  margin-top: 10px;
`;

const SwitchLangButton: React.FC<{
  selectedLang: string;
  changeLang: (locale: string) => void;
}> = ({ selectedLang, changeLang }) => (
  <Wrapper>
    <Select
      defaultValue={selectedLang}
      onChange={(v) => changeLang(String(v))}
      variant="borderless"
      dropdownStyle={{ textAlign: 'center' }}
      options={languages
        .filter((l) => l.active)
        .map((l) => ({
          label: l.flagIcon,
          value: l.prefix,
        }))}
      css={`
        .ant-select-arrow {
          color: #fff;
        }
        .ant-select-selection-item {
          margin-top: 10px;
        }
      `}
    />
  </Wrapper>
);

export default SwitchLangButton;
